<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="login h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title">
                  <h4 class="mb-4">
                    {{
                      typeForm === "login"
                        ? "Ingresar"
                        : "Restablecer contraseña"
                    }}
                  </h4>

                  <p v-if="typeForm === 'login'">
                    Bienvenido de nuevo, inicie sesión en su cuenta.
                  </p>

                  <p v-else>
                    Ingrese su correo electrónico para recuperar el acceso a su
                    cuenta.
                  </p>
                </div>

                <form
                  @submit.prevent="login()"
                  class="login__form"
                  v-if="typeForm === 'login'"
                >
                  <vs-input
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full"
                  />

                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full mt-6"
                  />

                  <div class="mt-3" v-if="error">
                    <p class="text-center text-danger">{{ error }}</p>
                  </div>

                  <div class="flex flex-wrap justify-between my-5">
                    <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Recuérdame</vs-checkbox> -->
                    <a href="" @click.prevent="typeForm = 'recover'"
                      >¿olvidó su contraseña?</a
                    >
                  </div>

                  <button
                    type="submit"
                    :disabled="!validate"
                    class="vs-component vs-button float-right mb-5 vs-button-primary vs-button-filled"
                  >
                    {{ loading ? "Ingresando" : "Ingresar" }}
                  </button>
                </form>

                <form
                  @submit.prevent="recover()"
                  v-if="typeForm === 'recover'"
                  class="login__form"
                >
                  <vs-input
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email"
                    v-model="email"
                    class="w-full"
                  />

                  <p class="mt-3" v-if="recoverSuccess">
                    Por favor revise su bandeja de entrada, para recuperar el
                    acceso a su cuenta.
                  </p>
                  <p class="mt-3" v-if="recoverError">
                    El correo electrónico no está registrado.
                  </p>

                  <div class="flex justify-between align-center mt-5">
                    <feather-icon
                      icon="ChevronLeftIcon"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      class="pointer"
                      @click.stop="typeForm = 'login'"
                    />

                    <button
                      type="submit"
                      :disabled="!email || loading"
                      class="vs-component vs-button float-right vs-button-primary vs-button-filled"
                    >
                      {{ loading ? "Enviando" : "Recuperar acceso" }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import login from "@/apollo/mutations/auth/login.gql";
import RecuperarContraUsuario from "@/apollo/mutations/auth/RecuperarContraUsuario.gql";

export default {
  data() {
    return {
      email: "",
      password: "",
      checkbox_remember_me: false,
      loading: false,
      error: null,
      typeForm: "login",
      recoverSuccess: false,
      recoverError: false,
      errores: [
        {
          value: "INICIE_FACEBOOK",
          message: "Usted está registrado con su cuenta de Facebook.",
        },
        {
          value: "INICIE_GOOGLE",
          message: "Usted está registrado con su cuenta de Google.",
        },
        {
          value: "INICIE_CORREO",
          message:
            "No está registrado con redes sociales, ingrese con correo y contraseña.",
        },
        {
          value: "CONTRASEÑA_INCORRECTA",
          message: "La contraseña en incorrecta.",
        },
        {
          value: "NO_EXISTE",
          message: "La cuenta no existe",
        },
      ],
    };
  },
  methods: {
    login() {
      if (this.validate) {
        this.error = false;
        this.loading = true;

        const input = {
          email: this.email,
          password: this.password,
          tipoInicio: 1,
        };

        const res = this.$apollo
          .mutate({
            mutation: login,
            variables: {
              input,
            },
            errorPolicy: 'all'
          })
          .then((res) => {
            // Verificar errores
            if (res.errors) {
              let codigoError = res.errors[0].debugMessage;

              this.setError(codigoError);
            } else {

              let data = res.data.login,
              token = res.data.login.api_token;

              let dataParaCookies = {
                id: data.id,
                name: data.name,
                surnames: data.surnames,
                email: data.email,
                typeUser: data.typeUser,
                urlPhoto: data.urlPhoto,
                photo: data.photo,
              };

              dataParaCookies = JSON.stringify(dataParaCookies);

              this.$cookies.set("kira_admin", token);
              this.$cookies.set("ka_udata", dataParaCookies);

              this.$store.dispatch("setUserAuth");
              this.$store.dispatch("setUserData");

              // Se asigna como true sesionIniciada en vuex ya que las cookies no se actualizan en la misma página
              // this.$store.commit("setSesionIniciada", true);

              this.$router.push("/");

              this.loading = false;
            }

            // Se verifica que no haya error en el token
            /*  if (token != "ERROR" && data.typeUser === 1) {
                
              } else {
                this.error = true;
                this.loading = false;
              } */
          });
      }
    },
    recover() {
      if (this.email) {
        this.recoverSuccess = false;
        this.recoverError = false;
        this.loading = true;

        const input = {
          email: this.email,
        };

        this.$apollo
          .mutate({
            mutation: RecuperarContraUsuario,
            variables: {
              input,
            },
          })
          .then((res) => {
            if (res.data.RecuperarContraUsuario) {
              this.recoverSuccess = true;

              this.email = "";
            } else {
              this.recoverError = true;
            }

            setTimeout(() => {
              this.recoverSuccess = false;
              this.recoverError = false;
            }, 5000);

            this.loading = false;
          });
      }
    },
    setError(value) {
      // Busca el valor del error enviado por el backend para mostrar un mensaje personalizado
      return new Promise((resolve) => {
        let errorActual = this.errores.find((item) => item.value === value);

        this.error = errorActual.message;

        resolve();
      });
    },
  },
  computed: {
    validate: function () {
      return this.email && this.password ? true : false;
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}

.login {
  &__form {
    margin-top: 4rem;
  }
}
</style>
